
export const uploadToMediaManagement = async ({
        aspectBannerRatio = null,
        aspectVideoRatio = null,

        marketingGoals,
        targetAudience,
        vibeAndTone,
        uploadData,
        setUploadAudioID,
        setUploadVideoID,
        setAllGenratedBanners,
        setAllGenratedVideos,
        setAllUploadedAudios,
        setSelectedVideo,
        getToken,
        configData,
        notify
  }) => {
        try {
        const ratio = {"16:9": "landscape", "9:16": "portrait"}
        const token = getToken()
        uploadData.tags = [
          ...(marketingGoals || []),
          ...(targetAudience || []),
          ...(vibeAndTone || []),
          ...(aspectBannerRatio ? [`${ratio[aspectBannerRatio]}`] : []),
          ...(aspectVideoRatio ? [`${ratio[aspectVideoRatio]}`] : [])
        ];
        // return
        const res = await fetch(`${configData.DEMO_URL}/UploadToMediaManagement`, {
            method: "POST",
            headers: {
            "x-access-token": token,
            "Content-Type": "application/json",
            // add auth token if needed
            },
            body: JSON.stringify(uploadData),
        });
  
        if (!res.ok) {
            throw new Error(`Server error while uploading media: ${res.status}`);
        }
        const response = await res.json();
        console.log(response)
  
        if (response?.data?.audio ?? null)
            setAllUploadedAudios(prev => [...prev, response.data.audio]);
        if (response?.data?.banner ?? null) {
          setAllGenratedBanners(prev => [...prev, response.data.banner]);
        }
        if (response?.data?.video ?? null) {
            setAllGenratedVideos(prev => [...prev, response.data.video]);
        }
        return
        // return data; // data should have the same shape as your previous `response.data`
        } catch (error) {
        notify("Failed to upload media:", "error");
        return false
        }
    };

export const handleUpload = async (profileBook, options = {}) => {
      const readValue = (key, fallback) => {
          if (profileBook && typeof profileBook.get === "function") {
              const value = profileBook.get(key);
              return value ?? fallback;
          }
          const value = profileBook?.[key];
          return value ?? fallback;
      };

      const baseUrl = options?.configData?.DEMO_URL || "";
      const token = typeof options?.getToken === "function" ? options.getToken() : null;

      const data = {
          marketing_goals: readValue("marketingGoals", readValue("marketing_goals", [])),
          vibe_and_tone: readValue("vibeAndTone", readValue("vibe_and_tone", [])),
          target_audience: readValue("targetAudience", readValue("target_audience", [])),
          logos: readValue("logos", []),
          company_name: readValue("companyName", readValue("company_name", "")),
          language: readValue("language", "English"),
          voice: readValue("voice", ""),
      };

      try {
          await fetch(`${baseUrl}/UpdateProfileBook`, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  ...(token ? { "x-access-token": token } : {}),
              },
              body: JSON.stringify(data),
          });
      } catch (error) {
          console.error("Error uploading profile book:", error);
      }
  };
  